import React from "react";
import "./SectionSeprator.scss";

const SectionSeprator = (props) => {
  return (
    <div className="sectionWrapper">
      <p className="title" style={{ color: props.color, fontSize: props.fontSize }}>
        {props.title}
      </p>
    </div>
  );
};

export default React.memo(SectionSeprator);
